import { render, staticRenderFns } from "./FullImage.vue?vue&type=template&id=6dc9e1a4"
import script from "./FullImage.vue?vue&type=script&lang=js"
export * from "./FullImage.vue?vue&type=script&lang=js"
import style0 from "./FullImage.vue?vue&type=style&index=0&id=6dc9e1a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports